module.exports = __webpack_public_path__ + "42c487281dd0ef3e3e89aae14b5cbbd9.pdf";